"use strict";

import ApiService from "@/core/services/api.service";

const baseURL = "TrackerStops";

export default {
  getAllTrackerStop() {
    return new Promise(resolve => {
      ApiService.get(`${baseURL}/GetAllTrackerStop`).then(({ data }) => {
        resolve(data);
      });
    });
  },
  saveTrackerStop(payload) {
    return new Promise(resolve => {
      const shapedPayload = payload.trackerStop.trackerIds.map(current => ({
        id: payload.trackerStop.id,
        trackerId: current,
        stopDate: payload.trackerStop.stopDate,
        reasonId: payload.trackerStop.reasonId,
        description: payload.trackerStop.description
      }));

      ApiService.post(`${baseURL}/SaveTrackerStop`, {
        trackerStops: shapedPayload
      }).result.then(({ data }) => {
        resolve(data);
      });
    });
  },
  getOneTrackerStop(trackerStopId) {
    return new Promise(resolve => {
      ApiService.get(
        `${baseURL}/GetOneTrackerStop`,
        `?stopID=${trackerStopId}`
      ).then(({ data }) => {
        resolve(data);
      });
    });
  },
  isDuplicate(payload) {
    return new Promise(resolve => {
      ApiService.post(`${baseURL}/IsDuplicate`, payload).result.then(
        ({ data }) => {
          resolve(data);
        }
      );
    });
  }
};
